import React, { useEffect, useState } from "react";
import Card from "../../components/Card";
import ImageInput from "../../components/ImageInput";
import TextInput from "../../components/TextInput";
import { InputController } from "../../hooks/input-controller";
import { UseApi } from "../../hooks/use-api";
import { ToastEmitter } from "../../Services/assets/toast-emitter";
import {
	AddCategory,
	DeleteCategory,
	GetCategories,
} from "../../Services/lib/admin";
import styles from "./Category.module.sass";
import cn from "classnames";
import Loader from "../../components/Loader";
import Icon from "../../components/Icon";
import { UseDisclosure } from "../../hooks/use-disclosure";
import Modal from "../../components/Modal";
import Confirm from "../../components/Confirm";
import TemplateModal from "../NewProduct/TemplateModal";
import EditCategory from "./edit";
import category_ from "../../i11/Category";
import { useUser } from "../../context";

const Category = () => {
	const { locale } = useUser();
	const [{ isLoading, data }, getCategories] = UseApi({
		service: GetCategories,
	});

	useEffect(() => {
		getCategories();
	}, []);

	const [category, setCategory] = useState();

	const { isOpen, onClose, onOpen } = UseDisclosure();
	const {
		isOpen: isOpenCreate,
		onClose: onCloseCreate,
		onOpen: onOpenCreate,
	} = UseDisclosure();

	const open_ = (e) => {
		console.log(e);
		onOpen();
		const { title, description, image, prior, tag, featured, _id } = e;
		setCategory({
			_id,
			title,
			description,
			image,
			prior,
			tag,
			featured,
		});
	};
	const close_ = () => {
		onClose();
		setCategory();
		getCategories();
	};

	return (
		<>
			<div className={styles.spacer} />
			<Card
				title={category_[locale].categories}
				classTitle="title-purple"
				head={
					<button className="button" onClick={onOpenCreate}>
						{category_[locale].add_category}
					</button>
				}
			>
				{isLoading && <Loader className={styles.loaderCenter} />}
				<div className={styles.categorieswrap}>
					{data?.map((e) => {
						return (
							<CategoryCard
								open_={open_}
								getCategories={getCategories}
								key={e._id}
								item={e}
							/>
						);
					})}
				</div>
			</Card>
			<TemplateModal visible={isOpen} onClose={close_}>
				{category && isOpen && (
					<EditCategory initial={category} close_={close_} />
				)}
			</TemplateModal>
			<TemplateModal visible={isOpenCreate} onClose={onCloseCreate}>
				{isOpenCreate && (
					<CreateCategory
						getCategories={getCategories}
						close_={onCloseCreate}
					/>
				)}
			</TemplateModal>
		</>
	);
};

const CategoryCard = ({ item, getCategories, open_ }) => {
	const { locale } = useUser();
	const [{ isLoading }, DeleteCategory_] = UseApi({
		service: DeleteCategory,
	});
	const {
		isOpen: confirmV,
		onClose: confirmC,
		onOpen: confirmO,
	} = UseDisclosure();
	const onConfirm = async () => {
		const res = await DeleteCategory_(item._id);
		if (res) {
			ToastEmitter({
				msg: "Category deleted",
				type: "success",
			});
			getCategories();
		}
	};
	return (
		<>
			<div className={styles.categoryCard}>
				<img alt={item.title} src={item.image} />
				<div>{item.title}</div>
				<div className={styles.hover}>
					<div>
						<button
							onClick={() => open_(item)}
							type="button"
							className="button-small"
						>
							<Icon size="24" name="edit" />
						</button>
						<button
							onClick={confirmO}
							type="button"
							className="button-small button-red"
						>
							<Icon size="24" name="trash" />
						</button>
					</div>
				</div>
			</div>
			<Modal visible={confirmV} onClose={confirmC}>
				<Confirm
					title={category_[locale].confirm_title}
					onCancel={confirmC}
					onConfirm={onConfirm}
					isLoading={isLoading}
				/>
			</Modal>
		</>
	);
};

export const CreateCategory = ({ getCategories, close_ }) => {
	const { locale } = useUser();
	const [{ isLoading }, create] = UseApi({
		service: AddCategory,
	});

	const [imgL, setL] = useState(false);

	const onSubmit = async (e) => {
		e.preventDefault();
		if (imgL) {
			ToastEmitter({
				msg: "Image is uploading, please wait",
				type: "info",
			});
		} else {
			const tmp = { ...body };
			tmp.image = tmp.image.core_image_url;
			const res = await create(tmp);
			if (res) {
				document.getElementById("create-category-form").reset();
				setBody({
					title: "",
					description: "",
					prior: 100,
					image: "",
					tag: [],
					featured: false,
				});
				setImageUrl_("");
				getCategories();
				close_();
				ToastEmitter({
					type: "success",
					msg: "Successfully created a category",
				});
			}
		}
	};

	const [body, setBody] = useState({
		title: "",
		description: "",
		image: "",
		prior: 100,
		tag: [],
		featured: false,
	});
	const title = InputController("title", setBody);
	const description = InputController("description", setBody);
	const prior = InputController("prior", setBody);
	const [imageUrl_, setImageUrl_] = useState("");

	const HandleChange = (e) => {
		setBody((p) => {
			return {
				...p,
				image: e,
			};
		});
	};

	return (
		<Card
			className={styles.edit}
			title={category_[locale].create_category}
			classTitle="title-purple"
		>
			<form
				id="create-category-form"
				onSubmit={onSubmit}
				className={styles.form}
			>
				<TextInput
					className={styles.field}
					label={category_[locale].name}
					name="title"
					type="text"
					// tooltip="Enter category name"
					required
					{...title}
				/>
				<TextInput
					className={styles.field}
					label={category_[locale].description}
					name="description"
					type="text"
					// tooltip="Enter category description"
					required
					textarea
					{...description}
				/>
				<TextInput
					className={styles.field}
					label={category_[locale].order}
					name="Order"
					type="number"
					// tooltip="Enter category name"
					required
					{...prior}
				/>
				<ImageInput
					imageUrl_={imageUrl_}
					setImageUrl_={setImageUrl_}
					where="CATEGORYS"
					callBack={HandleChange}
					className={styles.field}
					label={category_[locale].image}
					required
					// tooltip="Image"
					setL={setL}
				/>

				<div className={styles.field}>
					<button className={cn("button", { disabled: isLoading })}>
						{isLoading && <Loader />}
						{category_[locale].save}
					</button>
				</div>
			</form>
		</Card>
	);
};

export default Category;
